<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="row mt-2" style="height: 100vh;">
                <div class="col-3">
                    <treeselect :searchable="false" :always-open="true" :options="listLayerMap" :normalizer="normalizer"
                        v-model="selectedLayerMap" placeholder="Chọn lớp dữ liệu" />
                </div>
                <div class="col-9">
                    <b-row>
                        <b-col>
                            <h5> Lớp dữ liệu </h5>
                        </b-col>
                        <b-col class="text-right">
                            <b-button class="mb-2" style="width: 200px;" variant="outline-primary"
                                @click="openCreateModal">
                                <i class="fa fa-plus-circle mr-2"></i>
                                <span class="text-uppercase">Thêm lớp dữ liệu</span>
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-for="item in listChildLayer" :key="item.id" md="3" sm="4" xs="6">
                            <b-card class="mb-2" align="center">
                                <b-icon variant="primary" icon="folder-fill" font-scale="4" class="cursor-pointer"
                                    @click="selectedLayerMap = item.id"></b-icon>
                                <b-card-text style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                    {{ item.name }}
                                </b-card-text>

                                <b-button variant="primary" class="mr-2" @click="openEditModal(item)">Sửa</b-button>
                                <b-button variant="danger" @click="openDeleteLayer(item)">Xoá</b-button>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row v-if="selectedLayerMap">
                        <b-col>
                            <h5 class="mt-3">Dữ liệu</h5>
                        </b-col>
                        <b-col class="text-right">
                            <b-button style="width: 200px;" class="mb-2" variant="outline-primary"
                                @click="openUploadModal">
                                <i class="fa fa-upload mr-2"></i>
                                <span class="text-uppercase">Tải lên dữ liệu</span>
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-for="item in listLayerFile" :key="item" xl="2" md="3" sm="4" xs="6">
                            <b-card class="mb-2 cursor-pointer" align="center" @click="openPreviewMapDialog(item)">
                                <b-icon variant="primary" :icon="getFileIcon(item)" font-scale="4"></b-icon>
                                <b-card-text style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                    {{ getFileName(item) }}
                                </b-card-text>
                                <b-button variant="danger" @click.stop="openDeleteFile(item)">Xoá</b-button>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <b-modal ref="createOrUpdateLayerModal" ok-title="Lưu" size="lg"
            :title="form.id ? `Cập nhật (ID: ${form.id})` : $t('common.create')" @ok="handleCreateLayerOk"
            :cancel-title="$t('common.cancel')">
            <b-form-group label="Tên">
                <b-form-input maxlength="255" v-model="form.name" v-validate="'required'" placeholder="Tên" name="name"
                    data-vv-as="Tên"></b-form-input>
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group label="Chọn icon cho điểm">
                <b-form-file v-model="file" placeholder="Chọn icon" accept="image/*" browse-text="Chọn"></b-form-file>
                <div v-if="form.pointIcon" class="mt-2">
                    <b-button variant="outline-danger" class="float-right" @click="form.pointIcon = null">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-img fluid style="max-width: 50px;"
                        :src="API_CONFIG.BASE_URL + 'download?fileName=' + form.pointIcon" />
                </div>
            </b-form-group>
            <b-form-group label="Kích thước icon">
                <b-form-input v-model="form.iconSize" placeholder="Kích thức icon" v-validate="'required'"
                    name="iconSize" data-vv-as="Kích thức icon" type="number"></b-form-input>
                <div v-show="errors.has('iconSize')" class="validation-message text-danger">
                    {{ errors.first('iconSize') }}
                </div>
            </b-form-group>
            <b-form-group label="Hiển thị mặc định">
                <b-form-checkbox v-model="form.defaultShow" switch></b-form-checkbox>
            </b-form-group>
            <b-form-group label="Hiển thị trên bản đồ">
                <b-form-checkbox-group v-model="form.mapShow" :options="mapDisplayTypeOptions" stacked />
            </b-form-group>
            <b-form-group label="Loại biểu đồ">
                <b-form-radio-group v-model="form.chartType">
                    <b-form-radio value="line">Đường</b-form-radio>
                    <b-form-radio value="bar">Cột</b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <b class="mb-1">Phân cấp màu:</b>
            <b-row class="mb-1">
                <b-col cols="3">
                    <b-form-label>Tên</b-form-label>
                </b-col>
                <b-col cols="3">
                    <b-form-label>Màu sắc</b-form-label>
                </b-col>
                <b-col cols="3">
                    <b-form-label>Icon</b-form-label>
                </b-col>
                <b-col cols="3">
                    <b-form-label>Giá trị giới hạn</b-form-label>
                </b-col>
            </b-row>
            <b-row v-for="(item, index) in legend" :key="index" class="mb-2">
                <b-col cols="3">
                    <b-form-input v-model="item.name"></b-form-input>
                </b-col>
                <b-col cols="3">
                    <b-form-input v-model="item.color" type="color"></b-form-input>
                </b-col>
                <b-col cols="3">
                    <div class="legend-icon-compact">
                        <b-form-file v-model="item.iconFile" accept="image/*" placeholder="Chọn" browse-text="Chọn"
                            @input="onLegendIconSelected(item)" class="legend-icon-input"></b-form-file>
                        <b-img v-if="getLegendIconPreview(item)" fluid class="legend-icon-preview"
                            :src="getLegendIconPreview(item)" />
                        <b-button v-if="getLegendIconPreview(item)" size="sm" variant="outline-danger"
                            class="legend-icon-remove" @click="clearLegendIcon(item)">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>
                </b-col>
                <b-col cols="3">
                    <b-row no-gutters>
                        <b-col cols="8">
                            <b-form-input v-model="item.value" type="number"></b-form-input>
                        </b-col>
                        <b-col cols="4" class="pl-2">
                            <b-button variant="danger" @click="removeLegendItem(item)">Xoá</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-button variant="primary"
                @click="legend.push({ color: '#000', icon: null, iconFile: null, iconPreview: null })">Thêm cấp
                màu</b-button>
        </b-modal>

        <b-modal ref="uploadDataModal" ok-title="Lưu" @ok="handleUploadOk" :cancel-title="$t('common.cancel')">
            <template #modal-title>
                <div class="d-flex align-items-center">
                    <span>Tải lên dữ liệu</span>
                    <b-button size="sm" variant="outline-info" class="ml-2 px-2 py-0" v-b-tooltip.hover
                        title="Hướng dẫn đẩy dữ liệu lên bằng API" @click.stop="openUploadGuideModal">?</b-button>
                </div>
            </template>
            <b-form-group label="File dữ liệu">
                <b-form-file v-model="file" v-validate="'required'" name="file"
                    accept=".geojson,.tif,.tiff,application/geo+json,application/json,image/tiff"
                    placeholder="Chọn file dữ liệu" drop-placeholder="Kéo file dữ liệu vào đây"></b-form-file>
                <div v-show="errors.has('file')" class="validation-message text-danger">
                    {{ errors.first('file') }}
                </div>
            </b-form-group>
        </b-modal>
        <b-modal ref="uploadGuideModal" title="Hướng dẫn đẩy dữ liệu lên bằng API" size="lg" hide-footer>
            <div class="mb-2 d-flex justify-content-between align-items-center">
                <span>Ví dụ Python:</span>
                <b-button size="sm" variant="outline-primary" @click="copyUploadGuideCode" v-b-tooltip.hover
                    title="Copy code">
                    <i class="fa fa-copy"></i>
                </b-button>
            </div>
            <pre class="api-guide-code mb-0"><code>{{ getUploadApiGuideCode() }}</code></pre>
            <div class="mt-3">
                <div class="font-weight-bold mb-2">Giải thích tham số:</div>
                <ul class="api-guide-list mb-0 pl-3">
                    <li><code>{id}</code>: ID lớp dữ liệu đang chọn.</li>
                    <li><code>file</code>: file dữ liệu cần upload (<code>.geojson</code>, <code>.tif</code>,
                        <code>.tiff</code>).
                    </li>
                </ul>
            </div>
        </b-modal>
        <PreviewMapDialog v-model="showPreviewMapDialog" :title="`Xem bản đồ: ${getFileName(selectedFileName)}`"
            :layer-id="selectedLayerMap" :file-name="selectedFileName" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import API_CONFIG from '@/api-config';
import PreviewMapDialog from '@/components/PreviewMapDialog';
import moment from 'moment-timezone';
export default {
    components: {
        Treeselect,
        PreviewMapDialog
    },
    async mounted() {
        await this.$nextTick();
        await this.getData();
    },
    beforeDestroy() {
        this.clearLegendPreviewUrls();
    },
    data: function () {
        return {
            API_CONFIG,
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'name',
                    label: 'Tên lớp dữ liệu'
                },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {
                name: '',
                type: 'layer'
            },
            showModalConfirm: false,
            searchKeyword: null,
            listLayer: [],
            selectedLayerMap: null,
            listLayerMap: [],
            listChildLayer: [],
            listLayerFile: [],
            file: null,
            legend: [],
            showPreviewMapDialog: false,
            selectedFileName: '',
            mapDisplayTypeOptions: [
                { text: 'Nước mặt', value: 'Nước mặt' },
                { text: 'Nước dưới đất', value: 'Nước dưới đất' },
                { text: 'Trợ giúp', value: 'Trợ giúp' }
            ]
        };
    },
    methods: {
        ...mapActions({
            getListLayer: 'mapLayer/getListLayer',
            createLayer: 'mapLayer/createLayer',
            updateLayer: 'mapLayer/updateLayer',
            deleteLayer: 'mapLayer/deleteLayer',
            getLayerTree: 'mapLayer/getListTree',
            getListFile: 'mapLayer/getListFile',
            deleteFile: 'mapLayer/deleteFile',
            uploadFile: 'mapLayer/uploadFile',
            upload: 'file/upload',
            createAuditByUser: 'user/createAuditByUser'
        }),
        async getData() {
            this.listLayer = await this.getListLayer({ type: 'layer' });
            this.listChildLayer = this.listLayer;
            this.listLayerMap = await this.getLayerTree({ type: 'layer' });
        },
        handleCreateLayerOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        handleUploadOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitUpload();
                }
            });
        },
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.clearLegendPreviewUrls();
            this.resetForm();
            this.form = { ...item };
            if (Array.isArray(item.mapShow)) {
                this.form.mapShow = [...item.mapShow];
            } else if (typeof item.mapShow === 'string' && item.mapShow) {
                this.form.mapShow = [item.mapShow];
            } else {
                this.form.mapShow = [];
            }
            if ((item.legend ?? []).length > 0) {
                this.legend = item.legend.map(legendItem => ({
                    ...legendItem,
                    iconFile: null,
                    iconPreview: null
                }));
            }
            this.$refs.createOrUpdateLayerModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateLayerModal.show();
        },
        openUploadModal() {
            this.file = null;
            this.$refs.uploadDataModal.show();
        },
        openUploadGuideModal() {
            this.$refs.uploadGuideModal.show();
        },
        resetForm() {
            this.clearLegendPreviewUrls();
            this.form = {
                name: '',
                type: 'layer',
                iconSize: 20,
                mapShow: []
            };
            this.file = null;
            this.legend = [
                { color: '#ff0000', icon: null, iconFile: null, iconPreview: null },
                { color: '#ffa500', icon: null, iconFile: null, iconPreview: null },
                { color: '#008000', icon: null, iconFile: null, iconPreview: null }
            ];
        },
        async submitForm() {
            const legend = [];
            for (const item of this.legend) {
                const legendItem = { ...item };
                if (legendItem.iconFile) {
                    const data = await this.upload({ formData: { file: legendItem.iconFile } });
                    legendItem.icon = data.path;
                }
                delete legendItem.iconFile;
                delete legendItem.iconPreview;
                legend.push(legendItem);
            }
            this.form.legend = legend;
            if (this.file) {
                const data = await this.upload({ formData: { file: this.file } });
                this.form.pointIcon = data.path;
            }
            if (this.form.id) {
                await this.updateLayer(this.form);
            } else {
                await this.createLayer({
                    ...this.form,
                    parentId: this.selectedLayerMap
                });
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật lớp dữ liệu' });
            this.listLayerMap = await this.getLayerTree({ type: 'layer' });
            this.listChildLayer = await this.getListLayer({
                type: 'layer',
                parentId: this.selectedLayerMap
            });
            this.$refs.createOrUpdateLayerModal.hide();
        },
        async submitUpload() {
            const formData = new FormData();
            formData.append('file', this.file);
            await this.uploadFile({
                id: this.selectedLayerMap,
                formData
            });
            this.listLayerFile = await this.getListFile({ id: this.selectedLayerMap });
            this.listLayerMap = await this.getLayerTree({ type: 'layer' });
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Tải lên dữ liệu của lớp dữ liệu' });
            this.$refs.uploadDataModal.hide();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        async openDeleteLayer(item) {
            const result = await this.$bvModal.msgBoxConfirm(
                'Bạn có chắc chắn muốn xoá lớp dữ liệu này?',
                {
                    title: 'Xác nhận',
                    okVariant: 'danger',
                    okTitle: 'Có',
                    cancelTitle: 'Không'
                }
            );
            if (result) {
                await this.deleteLayer({ id: item.id });
                await this.getData();
                this.$toaster.success('Thành công');
                this.createAuditByUser({ content: 'Xoá lớp dữ liệu' });
            }
        },
        async openDeleteFile(item) {
            const result = await this.$bvModal.msgBoxConfirm(
                'Bạn có chắc chắn muốn xoá dữ liệu này?',
                {
                    title: 'Xác nhận',
                    okVariant: 'danger',
                    okTitle: 'Có',
                    cancelTitle: 'Không'
                }
            );
            if (result) {
                await this.deleteFile({ id: this.selectedLayerMap, fileName: item });
                this.listLayerFile = await this.getListFile({ id: this.selectedLayerMap });
                this.$toaster.success('Thành công');
                this.createAuditByUser({ content: 'Xoá dữ liệu của lớp dữ liệu' });
            }
        },
        getFileName(item) {
            try {
                if (item.match(/^\d{8}T\d{4}\.\w+$/)) {
                    const date = moment(item.split('.')[0], 'YYYYMMDDTHHmm').toDate();
                    return moment(date).format('DD/MM/YYYY HH:mm');
                }
            } catch (error) { }
            return item;
        },
        getFileIcon(item) {
            const ext = item.split('.').pop().toLowerCase();
            if (ext === 'geojson') return 'file-earmark-code-fill';
            if (ext === 'tif' || ext === 'tiff') return 'file-earmark-image-fill';
            return 'file-earmark-fill';
        },
        openPreviewMapDialog(fileName) {
            this.selectedFileName = fileName;
            this.showPreviewMapDialog = true;
        },
        getUploadApiGuideCode() {
            const layerId = this.selectedLayerMap || '<layerId>';
            return `import requests

url = "https://giamsatdubaotainguyennuoc.wri.vn/api/map-layer/${layerId}/file"
headers = {
  "key": "wETb4cnl2UgI9XRy"
}

with open("/path/to/data.geojson", "rb") as f:
    files = {"file": ("data.geojson", f)}
    response = requests.post(url, headers=headers, files=files)

print(response.text)`;
        },
        async copyUploadGuideCode() {
            const code = this.getUploadApiGuideCode();
            try {
                if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText(code);
                } else {
                    const textarea = document.createElement('textarea');
                    textarea.value = code;
                    textarea.setAttribute('readonly', '');
                    textarea.style.position = 'absolute';
                    textarea.style.left = '-9999px';
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                }
                this.$toaster.success('Đã copy code');
            } catch (error) {
                this.$toaster.error('Không thể copy code');
            }
        },
        getLegendIconUrl(path) {
            if (!path) return '';
            if (path.startsWith('http://') || path.startsWith('https://')) return path;
            return API_CONFIG.BASE_URL + 'download?fileName=' + path;
        },
        getLegendIconPreview(item) {
            if (item?.iconPreview) return item.iconPreview;
            if (item?.icon) return this.getLegendIconUrl(item.icon);
            return '';
        },
        onLegendIconSelected(item) {
            if (item.iconPreview) {
                URL.revokeObjectURL(item.iconPreview);
                item.iconPreview = null;
            }
            if (item.iconFile instanceof File) {
                item.iconPreview = URL.createObjectURL(item.iconFile);
            }
        },
        clearLegendPreviewUrls() {
            for (const item of this.legend) {
                if (item?.iconPreview) {
                    URL.revokeObjectURL(item.iconPreview);
                    item.iconPreview = null;
                }
            }
        },
        clearLegendIcon(item) {
            if (item.iconPreview) {
                URL.revokeObjectURL(item.iconPreview);
            }
            item.icon = null;
            item.iconFile = null;
            item.iconPreview = null;
        },
        removeLegendItem(item) {
            if (item?.iconPreview) {
                URL.revokeObjectURL(item.iconPreview);
            }
            this.legend.splice(this.legend.indexOf(item), 1);
        }
    },
    watch: {
        async selectedLayerMap(val) {
            this.listChildLayer = await this.getListLayer({ type: 'layer', parentId: val });
            if (val) this.listLayerFile = await this.getListFile({ id: val });
            else this.listLayerFile = [];
        }
    }
};
</script>

<style scoped>
.legend-icon-compact {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.legend-icon-input {
    flex: 1;
}

::v-deep .legend-icon-input .custom-file-label,
::v-deep .legend-icon-input .custom-file-label::after {
    height: 30px;
    line-height: 1.35;
    font-size: 0.8rem;
}

.legend-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    background: #fff;
}

.legend-icon-remove {
    padding: 0.05rem 0.35rem;
}

.api-guide-code {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 12px;
    white-space: pre-wrap;
}
</style>
